/*
 *###############################################################################
 *Module Name                   : VoucherGRNDetails.js                     #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  W M Shanika Chamodi                          #
 *Date                          : Friday, October 12th 2021, 3:20:00 pm          #
 *Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */

import React, { useState } from "react"
import { Row, Col, Button, Label } from "reactstrap"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import DPAlert from "../../../framework/widgets/DPAlert"
import { Numeric } from "../../../framework/validators/TextValidation" // Textbox input validations
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"

const VoucherGRNDetails = ({
  DataRow,
  RemoveRow,
  BookChange,
  AddRow,
  TotalBookQty,
  TotalCostValue,
  TotalSellingValue,
  GrossAmount,
  DiscountPer,
  texAmount,
  ETaxAmount,
  AddAmount,
  DedAmount,
  NetAmount,
  DiscountPer_OnChange,
  AddAmount_OnChange,
  DedAmount_OnChange,
  DiscountPer_OnBlur,
  AddAmount_OnBlur,
  DedAmount_OnBlur,
  rowsTax,
  SupplierCode,
  ShowTaxTable,
  blDiasableGrid,
  menuCode,
  setGridRows,
  SupplierTax,
  setTax,
  voucherPORef,
  menuName
}) => {



  function HandleRowChanges(value, index, field) {
    let rows = [...DataRow]
    rows[index][field] = value
    setGridRows(rows)
  }

  function HandleObjectCHanges(row, index) {
    let rows = [...DataRow]
    rows[index] = row
    setGridRows(rows)
  }


  function HandleTaxRowChange(index, code, costValue) {

    // let row = []
    // let TaxRows = [...rowsTax]

    // row = rowsTax.filter((row) => row.code == code)

    // if (row.length > 0) {

    //   row.map((item, index) => {
    //     var newItem = item
    //     newItem.grossAmt = costValue
    //     if (item.isInclude == 1) {
    //       var TaxIncAmt = parseFloat(parseFloat(costValue) * parseFloat(item.TaxRate) / (100 + parseFloat(item.TaxRate))).toFixed(2)
    //       newItem.TaxAmount = TaxIncAmt
    //     } else {
    //       var TaxExAmt = parseFloat(parseFloat(costValue) * parseFloat(item.TaxRate) / 100).toFixed(2)
    //       newItem.TaxAmount = TaxExAmt
    //     }

    //     let indexRow = rowsTax.findIndex((row) => row.code == code && row.TaxCode == item.TaxCode)

    //     TaxRows[indexRow] = newItem

    //   })

    //   setTax(TaxRows)
    // }

  }



  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={12} className="mb-12-sm">
          <table style={{ fontSize: "11px" }} id={"VoucherPODet"}>
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th style={{ textAlign: "left" }}>Voucher Group</th>
                <th>&nbsp;</th>
                <th style={{ textAlign: "left" }}>Group Description </th>
                <th style={{ textAlign: "right" }}>Cost</th>
                <th style={{ textAlign: "right" }}>Selling (Per Voucher)</th>
                <th style={{ textAlign: "right" }}>Starting Book No.</th>
                <th style={{ textAlign: "right" }}>No. of Books</th>
                <th style={{ textAlign: "right" }}>Ending Book No.</th>
                <th style={{ textAlign: "right" }}>Cost Value</th>
                <th style={{ textAlign: "right" }}>Selling Value</th>
              </tr>
            </thead>
            <tbody>
              {(DataRow || []).map((formRow, key) => (
                <TableRow
                  FormRow={formRow}
                  Key={key}
                  RemoveRow={RemoveRow}
                  Disabled={blDiasableGrid}
                  BookChange={BookChange}
                  SupplierCode={SupplierCode}
                  menuCode={menuCode}
                  HandleRowChanges={HandleRowChanges}
                  DataRow={DataRow}
                  SupplierTax={SupplierTax}
                  rowsTax={rowsTax}
                  setTax={setTax}
                  HandleTaxRowChange={HandleTaxRowChange}
                  AddRow={AddRow}
                  VoucherPORef={voucherPORef}
                  HandleObjectCHanges={HandleObjectCHanges}
                  menuName={menuName}
                />
              ))}
            </tbody>
            <tfoot>
              <tr>
                <th>&nbsp;</th>
                <th style={{ textAlign: "center" }}>&nbsp;</th>
                <th>&nbsp;</th>
                <th style={{ textAlign: "center" }}>&nbsp;</th>
                <th style={{ textAlign: "center" }}>&nbsp;</th>
                <th style={{ textAlign: "center" }}>&nbsp;</th>
                <th style={{ textAlign: "left" }}>Total</th>
                <th style={{ textAlign: "right" }}><DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  textType="text"
                  maxLength="8"
                  textAlign="right"
                  disabled={true}
                  value={TotalBookQty}

                ></DPTextBoxforgrid></th>
                <th style={{ textAlign: "center" }}>&nbsp;</th>
                <th style={{ textAlign: "right" }}><DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  textType="text"
                  maxLength="8"
                  textAlign="right"
                  disabled={true}
                  value={TotalCostValue}
                ></DPTextBoxforgrid></th>
                <th style={{ textAlign: "right" }}>
                  <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    labelText="Code"
                    textType="text"
                    maxLength="8"
                    textAlign="right"
                    disabled={true}
                    value={TotalSellingValue}
                  ></DPTextBoxforgrid>
                </th>
              </tr>
            </tfoot>
          </table>
          <Button
            onClick={() => {
              var emptyRow = DataRow.filter((row) => row.code == "")
              if (emptyRow.length == 0) {
                AddRow()
              }
            }}
            disabled={blDiasableGrid}
            color="success"
            className="mt-1"
            size="sm"
          >
            <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
          </Button>
        </Col>
        <Col sm={12} md={7} className="mb-12-sm">
          {rowsTax.length > 0 ? (
            <table style={{ fontSize: "11px" }} id={"TaxDet"}>
              <thead className="table-light">
                <tr>
                  <th style={{ textAlign: "left" }}>Voucher Group</th>
                  <th style={{ textAlign: "left" }}>Group Description </th>
                  <th style={{ textAlign: "left" }}>Tax</th>
                  <th style={{ textAlign: "right" }}>Gross Amount</th>
                  <th style={{ textAlign: "right" }}>Tax Rate</th>
                  <th style={{ textAlign: "left" }}>Is Inclusive</th>
                  <th style={{ textAlign: "right" }}>Tax Amount</th>
                </tr>
              </thead>
              <tbody>
                {(rowsTax || []).map((formRow, key) => (
                  <TableTaxRow FormRow={formRow} Key={key} />
                ))}
              </tbody>
            </table>
          ) : null}

        </Col>
        <Col sm={12} md={5} className="mb-12-sm">
          <Row>
            <Col sm={6}>
              <Label
                htmlFor="example-text-input"
                className={`col-md-12 col-form-label-sm`}
              >
                Gross Amount
              </Label>
            </Col>
            <Col sm={6} style={{ textAlign: "right" }}>
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText="Code"
                textType="text"
                maxLength="8"
                disabled={true}
                textAlign="right"
                value={GrossAmount}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Label
                htmlFor="example-text-input"
                className={`col-md-12 col-form-label-sm`}
              >
                Discount(%)
              </Label>
            </Col>
            <Col sm={6} style={{ textAlign: "right" }}>
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText="Code"
                textType="text"
                maxLength="8"
                textAlign="right"
                disabled={blDiasableGrid}
                value={DiscountPer}
                onChange={DiscountPer_OnChange}
                onBlur={DiscountPer_OnBlur}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Label
                htmlFor="example-text-input"
                className={`col-md-12 col-form-label-sm`}
              >
                Additions
              </Label>
            </Col>
            <Col sm={6} style={{ textAlign: "right" }}>
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText="Code"
                textType="text"
                maxLength="8"
                textAlign="right"
                disabled={blDiasableGrid}
                value={AddAmount}
                onChange={AddAmount_OnChange}
                onBlur={AddAmount_OnBlur}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Label
                htmlFor="example-text-input"
                className={`col-md-12 col-form-label-sm`}
              >
                Deductions
              </Label>
            </Col>

            <Col sm={6} style={{ textAlign: "right" }}>
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText="Code"
                textType="text"
                maxLength="8"
                textAlign="right"
                disabled={blDiasableGrid}
                value={DedAmount}
                onChange={DedAmount_OnChange}
                onBlur={DedAmount_OnBlur}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Label
                htmlFor="example-text-input"
                className={`col-md-12 col-form-label-sm`}
              >
                Tax(Inclusive)
              </Label>
            </Col>
            <Col sm={6} style={{ textAlign: "right" }}>
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText="Code"
                textType="text"
                maxLength="8"
                disabled={true}
                textAlign="right"
                value={texAmount}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Label
                htmlFor="example-text-input"
                className={`col-md-12 col-form-label-sm`}
              >
                Tax(Exclusive)
              </Label>
            </Col>
            <Col sm={6} style={{ textAlign: "right" }}>
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText="Code"
                textType="text"
                maxLength="8"
                disabled={true}
                textAlign="right"
                value={ETaxAmount}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Label
                htmlFor="example-text-input"
                className={`col-md-12 col-form-label-sm`}
              >
                Net Amount
              </Label>
            </Col>
            <Col sm={6} style={{ textAlign: "right" }}>
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText="Code"
                textType="text"
                maxLength="8"
                disabled={true}
                textAlign="right"
                value={NetAmount}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  )
}
export default VoucherGRNDetails

const TableRow = ({ FormRow, Key, RemoveRow, Disabled, HandleRowChanges,
  BookChange, SupplierCode, menuCode, DataRow, SupplierTax, rowsTax, setTax, HandleTaxRowChange, AddRow, VoucherPORef, HandleObjectCHanges, menuName }) => {

  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)

  const [Datatablesub, SetDatatablesub] = useState([])
  const [groupFilter, SetGroupFilter] = useState('a')

  const ApiURL = window.Links.ApiURL

  async function clickSearch() {

    if (SupplierCode == "") {
      setAlertDescription("Please Select Supplier First")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
    }
    else {
      tog_xlarge()
    }
  }

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]


  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }


  const Hed_SelectRowSearch = (e, row, isSelect, rowIndex) => {
    if (CodeValidation(row.VCG_CODE, "txtcode" + Key)) {

      var filterFromRef = VoucherPORef.filter((item) => item.code == row.VCG_CODE)

      if (filterFromRef.length > 0) {
        VoucherGroupCodeSearch(row.VCG_CODE, filterFromRef)
      } else {
        setAlertDescription("Selected Voucher Group Code is not available in the Voucher PO!")
        setAlertConfirmOption(4)
        setsweetAlertShow(true)
      }

      setmodal_xlarge(!modal_xlarge)
    }
    else {
      setAlertDescription("Code already used")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
    }
  }

  function SetRowEmpty() {



    var newRow = FormRow
    newRow.code = ""
    newRow.desc = ""
    newRow.Cost = 0
    newRow.Selling = 0
    newRow.StartBook = 0
    newRow.EndBook = 0
    newRow.NoOfBook = 0
    newRow.CostValue = 0
    newRow.SellingValue = 0
    newRow.rate = 0

    HandleObjectCHanges(newRow, Key)

  }

  function VoucherGroupCodeSearch(value, PORef = []) {
    const authToken = localStorage.getItem("authToken")
    if (value != "") {
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}VoucherPO/search/${value}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
      })
        .then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {
            const newArray = responseData.data[0]

            let currentRow = FormRow
            // HandleRowChanges(newArray.strCode, Key, "code")
            // HandleRowChanges(newArray.strName, Key, "desc")
            // HandleRowChanges(newArray.dbCost, Key, "Cost")
            // HandleRowChanges(parseFloat(newArray.dbValue).toFixed(2), Key, "Selling")
            // HandleRowChanges(PORef.length > 0 ? PORef[0].StartBook : newArray.dbBookNo + 1, Key, "StartBook")
            // HandleRowChanges(newArray.dbBookQty, Key, "rate")
            // HandleRowChanges(PORef.length > 0 ? PORef[0].EndBook : 0, Key, "EndBook")
            // HandleRowChanges(PORef.length > 0 ? PORef[0].NoOfBook : 0, Key, "NoOfBook")
            // HandleRowChanges(0, Key, "CostValue")
            // HandleRowChanges(0, Key, "SellingValue")

            currentRow.code = newArray.strCode
            currentRow.desc = newArray.strName
            currentRow.Cost = newArray.dbCost
            currentRow.Selling = parseFloat(newArray.dbValue).toFixed(2)
            currentRow.StartBook = PORef.length > 0 ? PORef[0].StartBook : newArray.dbBookNo + 1
            currentRow.rate = newArray.dbBookQty
            currentRow.EndBook = PORef.length > 0 ? PORef[0].EndBook : 0
            currentRow.NoOfBook = PORef.length > 0 ? PORef[0].NoOfBook : 0
            currentRow.CostValue = 0
            currentRow.SellingValue = 0

            HandleObjectCHanges(currentRow, Key)

            setTimeout(() => {
              document.getElementById("txtNoOfBook" + Key).focus()
            }, 10);

            var tax = [...rowsTax]

            SupplierTax.map((item, index) => {
              tax.push({
                id: tax.length == 0 ? 1 : tax[tax.length - 1].id + 1,
                code: newArray.strCode,
                desc: newArray.strName,
                TaxCode: item.TaxCode,
                grossAmt: 0,
                TaxRate: item.TaxRate,
                isInclude: item.isInclude,
                TaxAmount: 0,
              })
            })

            setTax(tax)

          } else {
            SetRowEmpty()
          }
        })
    } else {
      SetRowEmpty()
    }
  }

  const CodeValidation = (strCode, method) => { //voucher code validation from repeating
    var filterItems = DataRow.filter(item => item.code == strCode) //check code is already used
    if (method == 1) {
      if (filterItems.length > 1) {
        return false
      }
    } else {
      if (filterItems.length > 0) {
        return false
      }
    }
    return true
  }
  //* End Code Validation   */
  return (
    <tr key={FormRow.id}>
      <td>
        {" "}
        <Row className="mb-1">
          <Col md="12">{Key + 1}</Col>
        </Row>
      </td>
      <td style={{ width: "90px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="3"
              id={"txtcode" + Key}
              value={FormRow.code}
              disabled={FormRow.desc == "" ? false : true}
              onChange={e => {
                //setcode(e.target.value)
                HandleRowChanges(e.target.value, Key, "code")
              }}
              onBlur={e => {
                if (SupplierCode == "") {
                  setAlertDescription("Please Select Supplier First")
                  setAlertConfirmOption(4)
                  setsweetAlertShow(true)
                }
                else {
                  if (CodeValidation(e.target.value, 1)) {
                    VoucherGroupCodeSearch(e.target.value)
                  } else {
                    setAlertDescription("Code already used")
                    setAlertConfirmOption(4)
                    setsweetAlertShow(true)
                    HandleRowChanges("", Key, "code")
                  }
                }
              }}
              onKeyPress={e => {
                if (e.key === "Enter") {
                  if (SupplierCode == "") {
                    setAlertDescription("Please Select Supplier First")
                    setAlertConfirmOption(4)
                    setsweetAlertShow(true)
                  }
                  else {
                    if (e.target.value == "") {
                      document.getElementById("btnSearch" + Key).focus()
                    } else if (CodeValidation(e.target.value, 1)) {
                      VoucherGroupCodeSearch(e.target.value)
                    } else {
                      setAlertDescription("Code already used")
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)
                      HandleRowChanges("", Key, "code")
                    }
                  }
                }
              }}
            />
          </Col>
        </Row>
      </td>
      <td>
        <Row className="mb-1">
          <Col md="12">
            <Button
              outline
              color="success"
              disabled={FormRow.desc == "" ? false : true}
              id={"btnSearch" + Key}
              onClick={clickSearch}
              size="sm"
            >
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>
      </td>
      <td style={{ width: "200px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="8"
              id={"txtdesc" + Key}
              value={FormRow.desc}
              disabled={true}
              onChange={e => {
                //setdesc(e.target.value)
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "100px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              textAlign="right"
              id={"txtCost" + Key}
              value={FormRow.Cost}
              disabled={true}
              onChange={e => {
                //setCost(e.target.value)
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "140px", textAlign: "right" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              defaultValue="0.0"
              textAlign="right"
              id={"txtSelling" + Key}
              value={FormRow.Selling}
              disabled={true}
              onChange={e => {
                //setSelling(e.target.value)
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "120px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              textAlign="right"
              id={"txtStartBook" + Key}
              value={FormRow.StartBook}
              disabled={true}
              onChange={e => {
                //setStartBook(e.target.value)
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "100px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              textAlign="right"
              disabled={Disabled}
              id={"txtNoOfBook" + Key}
              value={FormRow.NoOfBook}
              onChange={e => {
                let valNoOfBook = Numeric(e.target, 8, 0, false)
                if (valNoOfBook == "") {
                  HandleRowChanges(0, Key, "NoOfBook")
                }
                else {
                  HandleRowChanges(valNoOfBook, Key, "NoOfBook")
                }
              }}
              onBlur={e => {

                if (FormRow.code != "") {

                  //get voucher group details from reference table


                  let VoucherGroupDetails = VoucherPORef.filter(x => x.code == FormRow.code)
                  let valNoOfBook = Numeric(e.target, 8, 2, false)
                  if (VoucherGroupDetails.length > 0) {

                    //check if no of book is greater than available book
                    if (parseInt(valNoOfBook) > parseInt(VoucherGroupDetails[0].NoOfBook)) {
                      setAlertDescription("No of book QTY can not exceed Reference QTY")
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)
                      HandleRowChanges(VoucherGroupDetails[0].NoOfBook, Key, "NoOfBook")
                      return
                    }

                    if (valNoOfBook == "") {
                      HandleRowChanges(0, Key, "NoOfBook")
                    }
                    else {
                      // HandleRowChanges(parseFloat(e.target.value, 10), Key, "NoOfBook")
                      // HandleRowChanges(parseFloat(FormRow.StartBook) + parseFloat(e.target.value) - 1, Key, "EndBook")
                      // HandleRowChanges(parseFloat(parseFloat(FormRow.Cost) * parseFloat(e.target.value)).toFixed(2), Key, "CostValue")
                      // HandleRowChanges(parseFloat(parseFloat(FormRow.Selling) * parseFloat(FormRow.rate) * parseFloat(e.target.value)).toFixed(2), Key, "SellingValue")

                      let currentRow = FormRow
                      currentRow.NoOfBook = parseFloat(e.target.value, 10)
                      currentRow.EndBook = parseFloat(e.target.value) == 0 ? 0 : parseFloat(parseFloat(FormRow.StartBook) + parseFloat(e.target.value) - 1)
                      currentRow.CostValue = parseFloat(parseFloat(FormRow.Cost) * parseFloat(e.target.value)).toFixed(2)
                      currentRow.SellingValue = parseFloat(parseFloat(FormRow.Selling) * parseFloat(FormRow.rate) * parseFloat(e.target.value)).toFixed(2)

                      HandleObjectCHanges(currentRow, Key)

                      HandleTaxRowChange(Key, FormRow.code, parseFloat(parseFloat(FormRow.Cost) * parseFloat(e.target.value)).toFixed(2))

                      BookChange()
                    }
                  } else {
                    setAlertDescription("Selected voucher code is not in voucher PO!")
                    setAlertConfirmOption(4)
                    setsweetAlertShow(true)
                    HandleRowChanges(0, Key, "NoOfBook")
                  }

                } else {
                  setAlertDescription("Please Enter Code First")
                  setAlertConfirmOption(4)
                  setsweetAlertShow(true)
                  HandleRowChanges(0, Key, "NoOfBook")
                }
              }}
              onKeyPress={e => {
                if (e.key === "Enter") {
                  if (FormRow.code == "") {
                    setAlertDescription("Please Enter Code First")
                    setAlertConfirmOption(4)
                    setsweetAlertShow(true)
                    HandleRowChanges(0, Key, "NoOfBook")
                    return
                  }

                  let VoucherGroupDetails = VoucherPORef.filter(x => x.code == FormRow.code)
                  let valNoOfBook = Numeric(e.target, 8, 2, false)

                  if (VoucherGroupDetails.length > 0) {
                    if (parseInt(valNoOfBook) > parseInt(VoucherGroupDetails[0].NoOfBook)) {
                      setAlertDescription("No of book QTY can not exceed Reference QTY")
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)
                      HandleRowChanges(VoucherGroupDetails[0].NoOfBook, Key, "NoOfBook")
                      return
                    }
                  }

                  if (e.target.value > 0) {

                    var emptyRow = DataRow.filter(x => x.code == "") // check is there any empty row

                    if (emptyRow.length > 0) return // if there is empty row then return

                    AddRow() // if there is no empty row then add new row
                    setTimeout(() => {
                      document.getElementById("txtcode" + (Key + 1)).focus() // focus on new row
                    }, 100);

                  } else {
                    setAlertDescription("Please Enter No Of Book")
                    setAlertConfirmOption(4)
                    setsweetAlertShow(true)
                  }
                }
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "120px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              textAlign="right"
              id={"txtEndBook" + Key}
              value={FormRow.EndBook}
              disabled={true}
              onChange={e => {
                //setEndBook(e.target.value)
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "120px", margin: "auto" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              defaultValue="0"
              textAlign="right"
              id={"txtCostValue" + Key}
              value={FormRow.CostValue}
              disabled={true}
              onChange={e => {
                //setCostValue(e.target.value)
                //  BookChange()
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "120px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              textAlign="right"
              id={"txtSellingValue" + Key}
              value={FormRow.SellingValue}
              disabled={true}
              onChange={e => {
                // setSellingValue(e.target.value)
                // BookChange(strCode)
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td>
        <Row className="mb-1">
          <Col md="1">
            <Button
              outline
              disabled={Disabled}
              color="danger"
              onClick={e => {
                RemoveRow(FormRow.id, FormRow.code)
              }}
              size="sm"
            >
              <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
            </Button>
          </Col>{" "}
        </Row>
      </td>


      <DPSearchBoxDynamic
        searchData={Datatablesub}
        columns={[]}
        defaultSorted={defaultSorted}
        mainTitle={menuName + " Search"}
        SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
        isOpen={modal_xlarge}
        toggle={tog_xlarge}
        getSelect={Hed_SelectRowSearch}
        APIURL={ApiURL}
        URLPath={"VOUGRP"}
        MenuCode={menuCode}
        KeyVal={'GRP'}
        searchBy={'VCG_CODE'}
        FilterStr={groupFilter}
      />




      <DPAlert
        confirm_both={sweetAlertShow}
        title={menuName}
        description={AlertDescription}
        showCancel={false}
        btnColor={"success"}
        cancelColor={"danger"}
        onConfirm={() => {
          setsweetAlertShow(false)
        }}
        btnYes={"OK"}


      />
    </tr>
  )
}
const TableTaxRow = ({ FormRow, Key }) => {
  return (
    <tr key={FormRow.id}>
      <td style={{ width: "80px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              textAlign="left"
              disabled={true}
              id={"txtVGroupCode" + Key}
              value={FormRow.code}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "200px" }}>
        <Row className="mb-1">

          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={true}
              textAlign="left"
              id={"txtVGroupName" + Key}
              value={FormRow.desc}
            ></DPTextBoxforgrid>

          </Col>
        </Row>
      </td>
      <td style={{ width: "80px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={true}
              textAlign="left"
              id={"txtTax" + Key}
              value={FormRow.TaxCode}
            ></DPTextBoxforgrid>

          </Col>

        </Row>
      </td>
      <td style={{ width: "100px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={true}
              textAlign="right"
              id={"txtGrossAmt" + Key}
              value={FormRow.grossAmt}
            ></DPTextBoxforgrid>

          </Col>

        </Row>
      </td>
      <td style={{ width: "100px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={true}
              textAlign="right"
              id={"txtTaxRate" + Key}
              value={FormRow.TaxRate}
            ></DPTextBoxforgrid>

          </Col>

        </Row>
      </td>
      <td style={{ width: "100px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              disabled={true}
              textType="text"
              textAlign="left"
              id={"txtIsInclude" + Key}
              value={FormRow.isInclude == 1 ? "Yes" : "No"}
            ></DPTextBoxforgrid>

          </Col>

        </Row>
      </td>
      <td style={{ width: "100px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={true}
              textAlign="right"
              id={"txtTaxAmount" + Key}
              value={parseFloat(FormRow.TaxAmount).toFixed(2)}
            ></DPTextBoxforgrid>

          </Col>

        </Row>

      </td>
    </tr>
  )
}
